import { render, staticRenderFns } from "./ListInventoryPending.vue?vue&type=template&id=833a0860&scoped=true&"
import script from "./ListInventoryPending.vue?vue&type=script&lang=js&"
export * from "./ListInventoryPending.vue?vue&type=script&lang=js&"
import style0 from "./ListInventoryPending.vue?vue&type=style&index=0&id=833a0860&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833a0860",
  null
  
)

export default component.exports